import React from 'react'
import { BaseCaseModelUpload } from './BaseCaseModelUpload'

export const BaseCaseModelPage: React.FC = () => {
    return <BaseCaseModelUpload />
}

export default BaseCaseModelPage
